import { ThisConnector } from '../../../api/connector'
import {
  BulkRouteActionByFiltersArgs,
  buildUrlParamsFromFilters
} from './shared'
import { BaseApiResponse } from '../../../api/shared'

export async function bulkDeleteRoutesByFilters(
  this: ThisConnector,
  {
    organizationUuid,
    applicationUuid,
    filters,
    excludedHashes
  }: BulkRouteActionByFiltersArgs
) {
  const params = buildUrlParamsFromFilters(filters)

  return this.connector.executeDelete<BaseApiResponse>(
    `/${organizationUuid}/applications/${applicationUuid}/route/bulk/filters?${params}`,
    {
      excludedHashes
    }
  )
}
